import React from 'react';
import { HiUsers, HiGlobe, HiLightBulb, HiScale } from 'react-icons/hi';
import { ClockIcon, TruckIcon, CogIcon,FlagIcon,EyeIcon, DocumentCheckIcon } from '@heroicons/react/24/outline';
import aboutImage from '../../Assets/images/about.png';
import partner1 from '../../Assets/images/partner1.avif';
import partner2 from '../../Assets/images/partner1.avif';
import partner3 from '../../Assets/images/partner1.avif';
import partner4 from '../../Assets/images/partner1.avif';
import partner5 from '../../Assets/images/partner1.avif';
import partner6 from '../../Assets/images/partner1.avif';
import isoImage from '../../Assets/images/iso.jpg';

function About() {
  // const stats = [
  //   { number: "20+", text: "Years of Experience" },
  //   { number: "500+", text: "Happy Clients" },
  //   { number: "50+", text: "Port Locations" },
  //   { number: "1000+", text: "Successful Projects" }
  // ];

  const values = [
    {
      icon: <HiUsers className="w-8 h-8" />,
      title: "Customer Focus",
      description: "We develop solutions by best understanding our customers' needs."
    },
    {
      icon: <HiGlobe className="w-8 h-8" />,
      title: "Global Service",
      description: "We are by your side at every point with our worldwide service network."
    },
    {
      icon: <HiLightBulb className="w-8 h-8" />,
      title: "Innovation",
      description: "We update our services by following continuously evolving technologies."
    },
    {
      icon: <HiScale className="w-8 h-8" />,
      title: "Reliability",
      description: "We provide quality service with transparent and reliable business processes."
    }
  ];

  
  const visionMission = {
    vision: {
      title: "Our Vision",
      description: "To become a leading global maritime services provider, setting industry standards for excellence and innovation in port operations and marine services.",
      icon: EyeIcon
    },
    mission: {
      title: "Our Mission",
      description: "To deliver reliable, efficient, and sustainable maritime solutions while maintaining the highest standards of safety and environmental responsibility.",
      icon: FlagIcon
    }
  };

  
  const qualityPolicies = [
    {
      title: "Safety First",
      description: "Maintaining the highest standards of safety in all operations"
    },
    {
      title: "Environmental Care",
      description: "Committed to sustainable practices and environmental protection"
    },
    {
      title: "Service Excellence",
      description: "Delivering consistent, high-quality service to all clients"
    },
    {
      title: "Continuous Improvement",
      description: "Regular evaluation and enhancement of our processes"
    }
  ];

  const partners = [
    { name: "Partner 1", logo: partner1 },
    { name: "Partner 2", logo: partner2 },
    { name: "Partner 3", logo: partner3 },
    { name: "Partner 4", logo: partner4 },
    { name: "Partner 5", logo: partner5 },
    { name: "Partner 6", logo: partner6 },
  ];

  return (
    <div className="pt-20 font-tt-lakes">
     
      <div className="bg-marine-black text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-2">
            About Us
          </h1>
          <div className="h-1 bg-marine-red rounded-full w-24 mx-auto mb-6"></div>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            With over 20 years of experience, we are among the leading organizations in the maritime industry.
          </p>
        </div>
      </div>

      
      {/* <div className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-marine-red mb-2">
                  {stat.number}
                </div>
                <div className="text-gray-600">
                  {stat.text}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div> */}

     
      <div className="py-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12">
            
            <div className="space-y-8">
              <div className="relative inline-block">
                <h2 className="text-3xl font-bold text-marine-black mb-2">
                  About Ayel Marine Electronics
                </h2>
                <div className="h-1 bg-marine-red rounded-full w-full"></div>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Established in Istanbul / Turkey for the sales, supply, support and on board services of maritime markets. Our founders has more than 20 years of experience in the maritime market. Ayel Marine aims to expand his experiences by spreading it to Turkish and International maritime sectors.
              </p>
              <p className="text-gray-600 leading-relaxed">
                The basic principles of our company, quality service and solution-oriented, featured products quickly and reliably is to supply the world's leading all ports.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Our team of highly qualified navigators, sales personnel, service coordinators, service engineers and technical specialists with proven competences and extensive experience guarantee to fulfil your requirements, technically and economically.
              </p>
              <div className="relative h-[300px] mt-8 rounded-xl overflow-hidden shadow-lg">
                <img
                  src={aboutImage}
                  alt="About Ayel Marine"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              </div>
            </div>

           
            <div className="space-y-6">
              <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100">
                <h3 className="text-xl font-bold text-marine-black mb-4 flex items-center">
                  <div className="p-3 bg-marine-red/10 rounded-lg mr-4">
                    <ClockIcon className="w-6 h-6 text-marine-red" />
                  </div>
                  24/7/365 Service
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  When we say 24 hours service hotline - we mean it. Wherever and whenever. Our dedicated service coordinators are ready to respond and to help you with whatever problem you are facing, no matter when and where you are.
                </p>
              </div>

              <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100">
                <h3 className="text-xl font-bold text-marine-black mb-4 flex items-center">
                  <div className="p-3 bg-marine-red/10 rounded-lg mr-4">
                    <TruckIcon className="w-6 h-6 text-marine-red" />
                  </div>
                  Logistics & Stock
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Punctual delivery is ensured by our advanced logistics and operations department. Ayel Marine has an extensive stock of equipment and spare parts available on all times to ensure a quick and effective solution.
                </p>
              </div>

              <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100">
                <h3 className="text-xl font-bold text-marine-black mb-4 flex items-center">
                  <div className="p-3 bg-marine-red/10 rounded-lg mr-4">
                    <CogIcon className="w-6 h-6 text-marine-red" />
                  </div>
                  Quality Service
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Our aim is to achieve highest degree of customer satisfaction in quality controlled routines.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

     
      <div className="py-16 bg-gradient-to-br from-gray-900 to-marine-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-2">
              Vision & Mission
            </h2>
            <div className="h-1 bg-marine-red rounded-full w-48 mx-auto"></div>
          </div>
          <div className="grid md:grid-cols-2 gap-12">
            {Object.values(visionMission).map((item, index) => (
              <div 
                key={index}
                className="bg-white/5 backdrop-blur-sm rounded-xl p-8 border border-white/10 hover:bg-white/10 transition-all duration-300"
              >
                <div className="flex items-center mb-6">
                  <div className="p-4 bg-marine-red rounded-lg mr-4">
                    <item.icon className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-white">
                    {item.title}
                  </h3>
                </div>
                <p className="text-gray-300 leading-relaxed text-lg">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      
      <div className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-marine-black mb-2">
              Our Values
            </h2>
            <div className="h-1 bg-marine-red rounded-full w-32 mx-auto"></div>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div 
                key={index}
                className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                <div className="text-marine-red mb-4">
                  {value.icon}
                </div>
                <h3 className="text-xl font-bold text-marine-black mb-2">
                  {value.title}
                </h3>
                <p className="text-gray-600">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="py-24 bg-marine-black">
       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
         <div className="text-center mb-16">
           <div className="flex justify-center mb-6">
             <DocumentCheckIcon className="w-12 h-12 text-marine-red" />
           </div>
           <h2 className="text-3xl md:text-4xl font-bold text-white mb-2">
             Quality Policy
           </h2>
           <div className="h-1 bg-marine-red rounded-full w-40 mx-auto mb-6"></div>
           <p className="text-gray-400 max-w-2xl mx-auto">
             Our commitment to maintaining the highest standards of service quality
           </p>
         </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
           {qualityPolicies.map((policy, index) => (
             <div 
               key={index}
               className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-8 hover:bg-white/10 transition-all duration-300"
             >
               <h3 className="text-xl font-bold text-white mb-3">
                 {policy.title}
               </h3>
               <p className="text-gray-300 leading-relaxed">
                 {policy.description}
               </p>
             </div>
           ))}
         </div>
       </div>
     </div>

     <div className="py-16 bg-white">
       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
         <div className="flex justify-center">
           <div className="relative w-full max-w-md">
             <img
               src={isoImage}
               alt="ISO Certification"
               className="w-full h-auto rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
             />
           </div>
         </div>
       </div>
     </div>
    </div>
  );
}

export default About;